import { useRecoilState } from "recoil";
import { gqlUserRecoilVar } from "State/User";
import { publishChanges } from "utils/hooks/webhooks";
import Report from "components/Report";
import Partner23Dashboard from "./Partner23Dashboard";

// The partner id for which the custom dashboard is shown.
// Must match GENDER_STATE_FILTER_PARTNER_ID in UsersFilter.jsx and
// CourseEnrolledUsers.jsx so all three files refer to the same partner.
const DASHBOARD_PARTNER_ID = 23;

export default function HomePage(props) {
  const [user] = useRecoilState(gqlUserRecoilVar);

  // Determine if the logged-in user belongs to partner 23.
  // user.partner_id is the direct partner_id on the user record.
  // The second check covers users linked via the partner_users relation
  // (same pattern used in UsersFilter and CourseEnrolledUsers).
  const isPartner23 =
    user?.partner_id === DASHBOARD_PARTNER_ID ||
    user?.partner_users?.some((pu) => pu.partner_id === DASHBOARD_PARTNER_ID);

  return (
    <div className="w-full h-full flex flex-col items-center pt-20 mt-8">
      {/* Default welcome header — always shown */}
      <div className="flex flex-col justify-center items-center">
        <div className="text-5xl font-semibold text-gray-300">
          <span className="text-gray-800">Admin Panel!</span>
          Welcome to <span className="text-orange">SkillsTrainer</span>{" "}
        </div>
        {user?.is_skillstrainer_admin && (
          <div className="mt-4">
            <button className="btn-primary" onClick={publishChanges}>
              Publish Marketing website
            </button>
          </div>
        )}
      </div>

      {/* SkillsTrainer admin: existing report */}
      {user?.is_skillstrainer_admin && (
        <Report type="home" hidePartners={true} />
      )}

      {/* Partner 23: custom analytics dashboard */}
      {isPartner23 && !user?.is_skillstrainer_admin && (
        <div className="w-full max-w-6xl mt-8">
          <Partner23Dashboard />
        </div>
      )}
    </div>
  );
}
